"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyGetResponseSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
const CompanyResultSchema = zod_1.z.object({ company: schemas_1.CompanyProfileSchema });
exports.CompanyGetResponseSchema = (0, schemas_1.createSuccessResponseSchema)(CompanyResultSchema);
